import { API_URL } from '../../constants';

type RedirectResponse = {
  redirected: true;
  redirectUrl: string | null;
  status: number;
};

type SuccessResponse<T = any> = {
  redirected: false;
  status: number;
  data: T | null;
  error?: string | null;
};

export type FetchWithRedirectResponse<T = any> =
  | RedirectResponse
  | SuccessResponse<T>;

export async function fetchWithRedirect<T = any>(
  url: string,
  options?: RequestInit,
): Promise<FetchWithRedirectResponse<T>> {
  const res = await fetch(`${API_URL}/v1/${url}`, {
    ...options,
    redirect: 'manual',
  });

  if (res.status === 301 || res.status === 302) {
    return {
      redirected: true,
      redirectUrl: res.headers.get('Location'),
      status: res.status,
    };
  }

  let data: any = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    let errorMessage = 'Something went wrong';

    if (typeof data?.message === 'string') {
      errorMessage = data.message;
    } else if (data?.errors && typeof data?.errors === 'object') {
      const firstError = Object.values(data.errors).find(Boolean);
      if (Array.isArray(firstError)) {
        const [first] = firstError;
        errorMessage = first;
      } else if (typeof firstError === 'string') {
        errorMessage = firstError;
      }
    }

    return {
      redirected: false,
      status: res.status,
      data: null,
      error: errorMessage,
    };
  }

  return {
    redirected: false,
    status: res.status,
    data,
    error: null,
  };
}
